import { useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultDiscovery, getWorkflowSteps } from "compid/workflows/BillDiscoveryWorkflow";
import React, { useState } from "react";

import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import UIButton from "compid/ui/UIButton";
import UICheckbox from "compid/ui/UICheckbox";

import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import "./styles.css";

/**
 * @function FindMyBillsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for FindMyBillsPage
 * @example
 * <FinMyBillsPage />
 */
export default function FindMyBillsPage(props){
  const workflowStep = useWorkflowStep(getDefaultDiscovery, getWorkflowSteps);

  const [ state, setState ] = useState(0);
  const toggleCheck = value => setState(value ? state + 1 : state - 1);

  const skip = evt => workflowStep.navigate("/paybills");
  const next = evt => {
    if(state > 0) {
      const { dispatcher, state } = workflowStep.globalController;

      dispatcher("updateModel", { ...state, "profile": { ...state.profile, "agreedToDiscovery" : "true" } });
      workflowStep.workflow.nextStep(workflowStep.defaultState);
    }
  };

  const disabled = state === 0 ? "disabled-button" : "";

  return (
    <PageView className="find-my-bills-page">
      <p className="page-sub-header semi-bold-text">FIND MY BILLS</p>

      <PageLayoutContainer>
        <CenterColumnContainer>
          <h2 className="text-center">Let's get started by finding the bills you pay</h2>
          <p><b>Choose how we find your bills.</b></p>

          <div className="form-group">
            <div className="flex-container flex-horizontal row-container form-row">
              <div className="set-width">
                <UICheckbox onChange={ toggleCheck } dataPoint="Bill_Discovery_Network_Checkbox" />
              </div>
              <div className="flex-width">
                <p><b>Bills from our biller network</b></p>
                <div className="gray-text sub-text">
                  <p>If you select this box, we'll see if your profile matches any bills we already have.</p>
                  <ul>
                    <li>You'll choose bills from companies in our service provider's network.</li>
                    <li>We'll use the bill info to make it easier for you to add them.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex-container flex-horizontal row-container form-row">
              <div className="set-width">
                <UICheckbox onChange={ toggleCheck } dataPoint="Bill_Discovery_Credit_Report" />
              </div>
              <div className="flex-width">
                <p><b>Your credit report</b></p>
                <div className="gray-text sub-text">
                  <p>If you select this box, you're consenting to our service provider accessing your consumer credit report from a credit bureau to help you add your bills.</p>
                  <ul>
                    <li>The report won't have your credit score.</li>
                    <li>Accessing it won't impact your score.</li>
                    <li>Your info won't be shared and will only be used to find bills you pay.</li>
                  </ul>
                </div>
              </div>
            </div>
            <ButtonContainer className="form-button-container">
              <UIButton className="secondary-button" onClick={ skip }>Skip</UIButton>
              <UIButton className={ `primary-button ${ disabled }` } onClick={ next } dataPoint="Bill_Discovery_Find_Bills">Find my bills</UIButton>
            </ButtonContainer>
          </div>
        </CenterColumnContainer>
      </PageLayoutContainer>
    </PageView>
  );
}